import PaymentsStore from "./Payments.Store";
import { RootStore } from "stores/index";
import { RouteType } from "types/RouteType";

const paymentsRoute: RouteType = {
  name: "Payments",
  path: "/accounting/payments",
  layout: "/app",
  viewportCard: {
    header: {
      title: "Payments",
      enableRefreshButton: true,
      enableBackButton: true,
      color: "primary",
      component: () => import("./Payments.Header"),
    },
    body: {
      component: () => import("./Payments.Body"),
      grayBackground: true,
    },
  },
  group: 'Accounting',
  requiresAuth: true,
  requiresAdmin: false,
  requiresPermission: false,
  // permissionPath: "accounting.payments",
  enableAutoFind: false,
  beforeEnter: async ({ rootStore }: { rootStore: RootStore }) => {
    const paymentsStore = rootStore.paymentsViewStore as PaymentsStore;
    await paymentsStore.loadPayments();
    return true;
  },
  dialogs: [
    {
      name: "recordPayment",
      title: "Record Payment",
      component: () => import("./PaymentsDialogs/RecordPaymentDialog.Body"),
      onSubmit: async ({ rootStore }: { rootStore: RootStore }) => {
        const paymentsStore = rootStore.paymentsViewStore as PaymentsStore;
        await paymentsStore.savePayment();
      },
      onSubmitValidation: ({ rootStore }: { rootStore: RootStore }) => {
        const paymentsStore = rootStore.paymentsViewStore as PaymentsStore;
        const formData = paymentsStore.formData;
        // Return true if validation fails (to disable submit button)
        return !formData.amount || !formData.paymentDate;
      },
      cancelButton: true,
      height: 630,
    },
    {
      name: "recordReceipt",
      title: "Record Receipt",
      component: () => import("./PaymentsDialogs/RecordReceiptDialog.Body"),
      onSubmit: async ({ rootStore }: { rootStore: RootStore }) => {
        const paymentsStore = rootStore.paymentsViewStore as PaymentsStore;
        await paymentsStore.savePayment();
      },
      onSubmitValidation: ({ rootStore }: { rootStore: RootStore }) => {
        const paymentsStore = rootStore.paymentsViewStore as PaymentsStore;
        const formData = paymentsStore.formData;
        // Return true if validation fails (to disable submit button)
        return !formData.amount || !formData.paymentDate;
      },
      cancelButton: true,
      height: 630,
    },
    {
      name: "paymentDetails",
      title: "Payment Details",
      component: () => import("./PaymentsDialogs/PaymentDetailsDialog.Body"),
      cancelButton: true,
      height: 650,
    },
  ],
};

export default paymentsRoute;
